import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Course } from "../academy/courses";
import { useGetMoneyTaxHomeDataQuery } from "../../store/api/moneyApi";
import LearnCard from "./tax/learnCard";

const sidebarItems = [
  {
    name: "Invest",
    route: "/money/invest",
  },
  {
    name: "Spend",
    route: "/money/spend",
  },
  {
    name: "Protect",
    route: "/money/protect",
  },
];

const comingSoon = [
  {
    name: "1% Club Portfolio",
    img: "/assets/money/sidebar-icon/portfolio.webp",
  },
  {
    name: "Stock Ideas",
    img: "/assets/money/sidebar-icon/stock.webp",
  },
  {
    name: "Mutual Funds",
    img: "/assets/money/sidebar-icon/mf.webp",
  },
];
const MoneySidebar = () => {
  const { data } = useGetMoneyTaxHomeDataQuery();
  const location = useLocation();
  const [selectedTab, setSelectedTab] = React.useState("Invest");
  const [learnCourse, setLearnCourse] = React.useState<Course | null>(null);
  const [istaxTab, setIstaxTab] = React.useState(false);
  useEffect(() => {
    const pathname = location.pathname.toLowerCase();

    if (pathname.includes("invest")) {
      setSelectedTab("Invest");
    } else if (pathname.includes("spend")) {
      setSelectedTab("Spend");
    } else if (pathname.includes("protect")) {
      setSelectedTab("Protect");
    }
    setIstaxTab(pathname.includes("tax"));
  }, [location.pathname]);
  useEffect(() => {
    if (data?.data?.learn?.courses?.[0]) {
      setLearnCourse(data?.data?.learn?.courses?.[0]);
    }
  }, [data]);
  return (
    <div className="flex flex-col gap-8">
      <div className="p-4 bg-white rounded-[12px]">
        <div className="flex items-center gap-2">
          <img
            src="/assets/money/money.webp"
            alt="Money Icon"
            className="w-[27.9px]"
          />
          <h1 className="text-[22px] font-[500]">Money</h1>
        </div>
        <div className="py-2">
          {sidebarItems.map((item, index) => (
            <Link to={item.route} onClick={() => setSelectedTab(item.name)}>
              <div
                key={index}
                className={`text-[17px] font-[500] px-2 py-3 ${item.name === selectedTab ? "bg-[#e7ecfc] rounded-[8px]" : "!text-[#808080]"}`}
              >
                {item.name}
              </div>
            </Link>
          ))}
        </div>
      </div>
      {selectedTab === "Invest" && (
        <div className="bg-white p-4 rounded-[12px]">
          <h2 className="text-[22px] font-[500]">Coming later this quarter</h2>
          <h4 className="text-[11px] bg-[#faf5e5] border-[1px] border-[#ecd996] w-fit py-1 px-3 rounded-[17px] font-normal text-[#090909]">
            Coming Soon
          </h4>
          <div className="flex flex-col gap-2 pt-[8px]">
            {comingSoon.map((item, index) => (
              <div
                key={index}
                className="flex gap-2 items-center bg-[#ebebeb] rounded-[10px] py-6 px-4 relative overflow-hidden"
              >
                <p className="font-bold">{item.name}</p>
                <img
                  src={item.img}
                  alt={item.name}
                  className="w-[92px] object-cover absolute right-0 top-3"
                />
              </div>
            ))}
          </div>
        </div>
      )}
      {istaxTab && learnCourse && <LearnCard learnCourse={learnCourse} />}
      <div className="flex flex-col gap-1 items-center text-[#999]">
        <img
          src="/assets/money/protect_shield.webp"
          alt="money sidebar"
          className="w-[47px]"
        />
        <h4 className="text-[17px] font-bold">Your Data is 100% Secure.</h4>
        <h5 className="text-[13px]">Trusted by 1.5 Lakh+ Indians</h5>
      </div>
    </div>
  );
};

export default MoneySidebar;
